import { AxiosError } from 'axios';
import { useCallback } from 'react';
import { logout } from 'actions/users';
import { useDispatch } from 'react-redux';
import { toastError } from 'components/Toast';
import { destroy } from 'store/slices/user';

export default function useLogout() {
  const dispatch = useDispatch();

  return useCallback(
    async function handleLogout() {
      try {
        await logout();
      } catch (error) {
        if ((error as AxiosError)?.response?.status !== 401) {
          toastError();
          return;
        }
      }

      dispatch(destroy());
    },
    [dispatch]
  );
}
